import React, { useState } from 'react';

// Componets
import ModalV2 from '@/views/components/modals/ModalV2';
import { EntityDetailsSummary } from '@/views/components/common/EntityDetailsSummary';

// Types
import { Action, BasicInfo, EntityDetails } from '@/types/EntityDetails';
import { GenericHouseHold } from '@/types/households';

// Utils
import { formatMessage } from '@/utils/i18n';

type Props = {
  hasDisplayedActions?: boolean;
  currentHousehold?: GenericHouseHold;
};

type ModalView = {
  showAddContactModal: boolean;
  showDeleteHouseholdModal: boolean;
  showEditHouseholdModal: boolean;
};

const HouseholdDetailsInfo = (props: Props) => {
  const { currentHousehold } = props;

  const [showModal, setShowModal] = useState<ModalView>({
    showAddContactModal: false,
    showDeleteHouseholdModal: false,
    showEditHouseholdModal: false,
  });
  const i18nBasePath = 'Households.HouseholdDetails';

  const toggleModal = (modal: keyof ModalView) => {
    setShowModal({
      ...showModal,
      [modal]: !showModal[modal],
    });
  };

  const renderActions = (): Action[] => {
    const { hasDisplayedActions } = props;

    if (!hasDisplayedActions) {
      return [];
    }

    return [
      {
        className: 'edit-household-btn',
        options: [
          {
            label: formatMessage(`${i18nBasePath}.Actions.AddContacts`),
            icon: 'ds-person-outline',
            onClick: () => {
              toggleModal('showAddContactModal');
            },
          },
          {
            label: formatMessage(`${i18nBasePath}.Actions.EditHousehold`),
            icon: 'pencil',
            onClick: () => {
              toggleModal('showEditHouseholdModal');
            },
          },
          {
            label: formatMessage(`${i18nBasePath}.Actions.DeleteHousehold`),
            icon: 'remove-new',
            onClick: () => {
              toggleModal('showDeleteHouseholdModal');
            },
            className: 'destructive',
          },
        ],
      },
    ];
  };

  const renderHouseholdBasicInfo = (): BasicInfo[] => {
    if (!currentHousehold) {
      return [];
    }

    return [
      {
        show: true,
        value: currentHousehold.name,
        className: 'name',
      },
    ];
  };

  const renderHouseholdDetails = (): EntityDetails[] => {
    if (!currentHousehold) {
      return [];
    }

    return [
      {
        show: true,
        value: currentHousehold.id,
        i18nPath: `${i18nBasePath}.HouseholdID`,
      },
    ];
  };

  return (
    <>
      <EntityDetailsSummary
        actions={renderActions()}
        entityBasicInfo={renderHouseholdBasicInfo()}
        entityDetails={renderHouseholdDetails()}
        icon={
          <div className="icon-container">
            <i className="icon-ds-groups" />
          </div>
        }
      />
      <ModalV2
        onClose={() => toggleModal('showAddContactModal')}
        show={showModal.showAddContactModal}
        title={formatMessage(`${i18nBasePath}.Modals.AddContacts.Title`)}
      />
      <ModalV2
        onClose={() => toggleModal('showDeleteHouseholdModal')}
        show={showModal.showDeleteHouseholdModal}
        title={formatMessage(`${i18nBasePath}.Modals.DeleteHousehold.Title`)}
      />
      <ModalV2
        onClose={() => toggleModal('showEditHouseholdModal')}
        show={showModal.showEditHouseholdModal}
        title={formatMessage(`${i18nBasePath}.Modals.EditHousehold.Title`)}
      />
    </>
  );
};

export default HouseholdDetailsInfo;
